<div
  class="min-h-screen min-w-[100vw] flex items-center justify-center bg-primary-100"
>
    <div class="container">
      <div class="card w-full">
        <div class="flex flex-row m-0">
          <p-button
            icon="ri-arrow-left-line"
            styleClass="p-button-rounded p-button-outlined"
            (onClick)="exit()"
          ></p-button>
        </div>
        <h2 class="my-4 text-2xl font-bold">¡Contrato firmado!</h2>
        <p class="mb-8">
          Esta operación se firmó el {{ this.op()?.closedDate | date }}. Si
          crees que se trata de un error contacta con tu asesora de Luxoro
        </p>
        <p-button
          (onClick)="dw.toggle($event)"
          [size]="'small'"
          label="Descargar contrato"
        />
        <p-overlayPanel #dw>
          <div class="flex items-center gap-2">
            <input
            pInputText
            placeholder="Introduce tu DNI"
            class="w-[25rem]"
            [(ngModel)]="opDni"
            (keyup)="onKeySearch($event)"
            (ngModelChange)="onKeySearch($event)"
          />
          @if (isValidDni) {
          <p-button [link]="true" label="Descargar" (onClick)="dw.toggle($event); downloadContract()"></p-button>
          } @else if (showLoading) {
          <p-progressSpinner
            styleClass="w-8 h-8"
            strokeWidth="2"
            animationDuration=".5s"
          />
          }
          </div>
        </p-overlayPanel>
      </div>
    </div>
</div>
